import i18next from 'i18next';
import { DateTime } from 'luxon';

import { SIMPLE_DATE, SHORT_DATE } from '../../constants/dates';
import parseDateTime from '../../dates/parseDateTime';
import dateFormatter from '../dateFormatter';

export default function formatDateRangeDay({
  _start,
  _end,
  i18n = i18next,
  timeZone,
  locale,
}: {
  _start: DateTime | Date | string;
  _end: DateTime | Date | string;
  i18n?: any;
  timeZone?: string;
  locale?: string;
}): string {
  const start = parseDateTime(_start, timeZone)!;
  const end = parseDateTime(_end, timeZone)!;
  const today = DateTime.local();

  if (timeZone) {
    today.setZone(timeZone);
  }

  const tomorrow = today.plus({ day: 1 });
  const yesterday = today.minus({ day: 1 });

  if (start.hasSame(today, 'day') && end?.hasSame(today, 'day')) {
    return i18n.t('shared.helpers.formatters.dateRange.today');
  }

  if (tomorrow.hasSame(start, 'day') && tomorrow.hasSame(end, 'day')) {
    return i18n.t('shared.helpers.formatters.dateRange.tomorrow');
  }

  if (yesterday.hasSame(start, 'day') && yesterday.hasSame(end, 'day')) {
    return i18n.t('shared.helpers.formatters.dateRange.yesterday');
  }

  if (start.hasSame(end, 'day')) {
    return `${dateFormatter(start, SHORT_DATE, timeZone, locale)}`;
  }

  if (start.hasSame(end, 'month')) {
    return i18n.t('shared.helpers.formatters.dateRange.range', {
      startTime: dateFormatter(start, SHORT_DATE, timeZone, locale),
      endTime: dateFormatter(end, 'd', timeZone, locale),
    });
  }

  if (start.hasSame(end, 'year')) {
    return i18n.t('shared.helpers.formatters.dateRange.range', {
      startTime: dateFormatter(start, SHORT_DATE, timeZone, locale),
      endTime: dateFormatter(end, SHORT_DATE, timeZone, locale),
    });
  }

  const startFormatted = dateFormatter(start, SIMPLE_DATE, timeZone, locale);
  const endFormatted = end
    ? dateFormatter(end, SIMPLE_DATE, timeZone, locale)
    : '…';

  return i18n.t('shared.helpers.formatters.dateRange.range', {
    startTime: startFormatted,
    endTime: endFormatted,
  });
}
